import { BlogPostContent } from '@/types/blog';
import { introSection } from './sections/intro';
import { transaktionenSection } from './sections/transaktionen';
import { miningStakingSection } from './sections/mining-staking';
import { airdropsSection } from './sections/airdrops';
import { emotionaleDimensionSection } from './sections/emotionale-dimension';
import { tippsSection } from './sections/tipps';
import { fazitSection } from './sections/fazit';

export const content: BlogPostContent = {
  sections: [
    introSection,
    transaktionenSection,
    miningStakingSection,
    airdropsSection,
    emotionaleDimensionSection,
    tippsSection,
    fazitSection
  ]
};
